import {GlassChip} from "@cupcodev/ui";

/** Only explicit package labels are decorated; ordinary words remain untouched. */
export const PackageLabel=({text}:{text:string})=> <>{text.replace(/\bcommon\.packageTier\.([A-Z0-9_-]+)\b/gu,"$1").split(/\b(STARTER|START|BASIC|STANDARD|PLUS|PRO|MAX|ULTRA|ENTERPRISE|PREMIUM|BUSINESS|FREE)\b/gi).map((part,index)=>index%2?<GlassChip key={index} variant="purple">{part.toUpperCase()}</GlassChip>:part)}</>;

export const ServiceIdentity=({name,logoUrl,planName}:{name:string;logoUrl?:string|undefined;planName?:string|undefined})=> <div className="customer-service-identity">
 {logoUrl?<img className="billing-service-logo" src={logoUrl} alt=""/>:null}
 <div><strong><PackageLabel text={name}/></strong>{planName&&planName!==name?<div className="customer-service-plan"><PackageLabel text={planName}/></div>:null}</div>
</div>;
